<template>
  <div class="solutions-area section-width ptb-100">
    <div class="container">
      <b-spinner variant="primary" label="Spinning" v-if="!news"></b-spinner>
      <div v-if="news">
        <h3 class="news-date">{{ postDate }}</h3>
        <h2 class="news-detail-title">{{ news.message_title }}</h2>
        <div class="card mb-3">
          <div class="card-body ck-content">
            <p v-html="news.message_content"></p>

            <div class="attachments" v-if="news.attachment && news.attachment.length">
              <div
                class="attachment-item"
                v-for="(file, index) in news.attachment"
                :key="index"
              >
                <div class="icon">
                  <i class="bi bi-tag-fill"></i>
                </div>
                <span class="file-name">
                  {{
                    file.description || file.file_description || file.file_name
                  }}
                  <span class="file-ext"
                    >.{{ getFileExtension(file.file_name) }}</span
                  >
                </span>
                <i
                  class="bi bi-download clickable-icon download-icon"
                  @click="downloadFile(file.path, file.file_name)"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsDetailBody",
  metaInfo() {
    return {
      title: this.news ? this.news.message_title : this.$t("navbar.menu_3_1"),
    };
  },
  data() {
    return {
      apiUrl: `${process.env.VUE_APP_API_URL}/announcement/`,
      news: null,
    };
  },
  computed: {
    postDate() {
      if (!this.news || !this.news.post_date) return "";
      return this.news.post_date.split(" ")[0];
    },
  },
  mounted() {
    this.getNewsDetail();
  },
  methods: {
    getNewsDetail() {
      const message_id = this.$route.params.id;
      const api = `${this.apiUrl}message?announcement_message_id=${message_id}&language_id=${this.$i18n.locale}&language_format=value`;
      this.axios.get(api).then((response) => {
        this.news = response.data;
      });
    },
    getFileExtension(filename) {
      if (!filename) return "";
      return filename
        .split(".")
        .pop()
        .toLowerCase();
    },
    async downloadFile(fileUrl, fileName) {
      try {
        if (!fileUrl) return;
        let downloadUrl = fileUrl;
        if (!downloadUrl.startsWith("http")) {
          downloadUrl = `/api${fileUrl.startsWith("/") ? "" : "/"}${fileUrl}`;
        }
        const response = await fetch(downloadUrl);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName || fileUrl.split("/").pop() || "download";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("下載失敗:", error);
      }
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 900px;
}

.news-date {
  color: #33ccff;
  font-size: 1.2em;
  margin-bottom: 10px;
}

.news-detail-title {
  margin-bottom: 30px;
}

.attachments {
  margin-top: 1rem;
}

.attachment-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #dee2e6;
  font-size: 14px;
}

.icon {
  margin-right: 0.5rem;
  font-size: 24px;
  color: #333;
}

.file-name {
  flex: 1;
  margin-left: 0.5rem;
  font-size: 18px;
  color: #333;
  word-break: break-all;
}

.file-ext {
  color: #333;
  font-size: 18px;
}

.download-icon {
  font-size: 20px;
  color: #007bff;
  cursor: pointer;
  margin-left: 1rem;
  transition: color 0.3s;
}
</style>

<style lang="css" src="assets/css/ckeditor.css"></style>
